/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} My_Groups_TitleInputs */

const en_my_groups_title = /** @type {(inputs: My_Groups_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`My Groups`)
};

const es_my_groups_title = /** @type {(inputs: My_Groups_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mis Grupos`)
};

const fr_my_groups_title = /** @type {(inputs: My_Groups_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mes Groupes`)
};

const de_my_groups_title = /** @type {(inputs: My_Groups_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meine Gruppen`)
};

const id_my_groups_title = /** @type {(inputs: My_Groups_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grup Saya`)
};

/** @type {(inputs: My_Groups_TitleInputs) => LocalizedString} */
const ja_my_groups_title = en_my_groups_title;

/** @type {(inputs: My_Groups_TitleInputs) => LocalizedString} */
const zh_my_groups_title = en_my_groups_title;

/** @type {(inputs: My_Groups_TitleInputs) => LocalizedString} */
const ar_my_groups_title = en_my_groups_title;

/** @type {(inputs: My_Groups_TitleInputs) => LocalizedString} */
const it_my_groups_title = en_my_groups_title;

/** @type {(inputs: My_Groups_TitleInputs) => LocalizedString} */
const ru_my_groups_title = en_my_groups_title;

/** @type {(inputs: My_Groups_TitleInputs) => LocalizedString} */
const pt_my_groups_title = en_my_groups_title;

/** @type {(inputs: My_Groups_TitleInputs) => LocalizedString} */
const ko_my_groups_title = en_my_groups_title;

/**
* | output |
* | --- |
* | "My Groups" |
*
* @param {My_Groups_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const my_groups_title = /** @type {((inputs?: My_Groups_TitleInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Groups_TitleInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_my_groups_title(inputs)
	if (locale === "es") return es_my_groups_title(inputs)
	if (locale === "fr") return fr_my_groups_title(inputs)
	if (locale === "de") return de_my_groups_title(inputs)
	if (locale === "ja") return ja_my_groups_title(inputs)
	if (locale === "zh") return zh_my_groups_title(inputs)
	if (locale === "ar") return ar_my_groups_title(inputs)
	if (locale === "id") return id_my_groups_title(inputs)
	if (locale === "it") return it_my_groups_title(inputs)
	if (locale === "ru") return ru_my_groups_title(inputs)
	if (locale === "pt") return pt_my_groups_title(inputs)
	return ko_my_groups_title(inputs)
});